export default "__VITE_ASSET__Bz2_9IuZ__"